import "core-js/modules/es.date.to-string.js";
import { differenceInYears, parse as dateParser } from 'date-fns';
import da from 'date-fns/locale/da/index';
import { FEMALE_NATIONAL_ID, MALE_NATIONAL_ID, INVALID, VALID } from './constants';
import { NON_DIGITS_REGEX } from '../regex';
var NATIONAL_ID_REGEX = /^\d{6}[-|(\s)]{0,1}\d{4}$/;

// code based on https://www.cpr.dk/media/17534/personnummeret-i-cpr.pdf

var getNationalIdChecksum = function getNationalIdChecksum(sanitizedNationalId) {
  var nationalId = sanitizedNationalId;
  var round1 = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
  return nationalId.split('').reduce(function (a, d, i) {
    return a + d * round1[i];
  }, 0) % 11 === 0;
};
var getCentury = function getCentury(cpr, currentDate) {
  var birthYear = parseInt(cpr.substr(4, 2), 10);
  var currentYear = currentDate.getFullYear() - 2000;

  // Assuming nobody older than 100 years will apply
  if (birthYear < currentYear) {
    return '20';
  }
  return '19';
};
var parse = function parse(nationalId) {
  var result = {
    lastDigits: '',
    birthDate: null,
    isDNumber: false,
    gender: null,
    age: null,
    valid: INVALID,
    nationalId: null,
    error: {
      type: 'genericError',
      message: "Invalid national Id: ".concat(nationalId)
    }
  };
  if (!nationalId || !String(nationalId || '').trim()) {
    result.error.type = 'length';
    result.error.message = 'Empty invalid national Id';
    return result;
  }
  var nationalID = nationalId.trim();
  if (nationalID.length !== 10 && nationalID.length !== 11) {
    result.error.type = 'length';
    result.error.message = "Invalid national Id length: ".concat(nationalId);
    return result;
  }
  var sanitized = nationalId.replace(NON_DIGITS_REGEX, '');
  if (!NATIONAL_ID_REGEX.test(sanitized)) {
    return result;
  }
  var epoch = new Date(0);
  var now = new Date();
  var day = sanitized.substring(0, 2);
  var month = sanitized.substring(2, 4);
  var year = sanitized.substring(4, 6);
  var lastDigits = sanitized.substring(6, 10);
  var genderDigit = Number.parseInt(lastDigits.charAt(3), 10);
  var century = getCentury(sanitized, now);
  var birthday = day + month + century + year;
  var birthDate = dateParser(birthday, 'ddMMyyyy', epoch, {
    locale: da
  });
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(birthDate)) {
    return result;
  }
  result.lastDigits = lastDigits;
  result.birthDate = birthDate.toISOString();
  result.gender = genderDigit % 2 === 0 ? FEMALE_NATIONAL_ID : MALE_NATIONAL_ID;
  result.age = differenceInYears(now, birthDate);
  var checksum = getNationalIdChecksum(sanitized);
  result.valid = checksum ? VALID : INVALID;
  result.nationalId = sanitized;
  result.error.type = null;
  result.error.message = null;
  return result;
};
export default parse;